<template>
  <form class="form loginForm" @submit.prevent="onSubmit()">
    <div class="form__create-acc" v-if="createAccInfo">
      <ul v-if="typeof createAccText === 'object' && createAccText.length > 1">
        <li
          v-for="item in createAccText"
          :key="item"
          v-html="item"
        />
      </ul>
      <div v-else-if="typeof createAccText === 'object'" v-html="createAccText[0]"></div>
      <div v-else v-html="createAccText"></div>
    </div>
    <template v-else>
      <fieldset v-if="tab==='login'">
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  type="text"
                  name="auth"
                  :placeholder="loginInputLabel"
                  v-model="auth"
                  v-validate.disable="'required'"
                  v-on:input="clearErrors()"
                  tabindex="1"
                  ref='firstInput'
            >

          </div>
          <label class="form__label">{{ loginInputLabel }}</label>
        </div>
        <div class="form__row">
          <div class="el-input">
            <input class="el-input__inner"
                  :type="!showPassword ? 'password' : 'text'"
                  name="password"
                  v-model="password"
                  :placeholder="$t('login.password_input.placeholder')"
                  v-validate.disable="'required'"
                  tabindex="2"
                  v-on:input="clearErrors()"
            >
            <span class="el-input__suffix" @click="showPassword = !showPassword">
              <span class="el-input__suffix-inner">
                <i v-if="!showPassword"
                class="el-input__icon fa fa-eye-slash"
                aria-hidden="true"
                :title="$t('login.password_input.show_hint')"></i>
              <i v-else
                class="el-input__icon fa fa-eye"
                aria-hidden="true"
                :title="$t('login.password_input.hide_hint')"></i>
              </span>
            </span>
          </div>
          <label class="form__label">{{ $t('login.password_input.label') }} </label>
        </div>
        <div class="form__row form--links">
          <div class="form__get-account">
            <a href="/" @click.prevent="$emit('showCreateAcc')">{{ $t('login.get_account_text') }}</a>
          </div>
          <div class="form__forgot-password">
            <a
              :href="forgetPasswordRedirect"
              @click="onForgetPasswordClick"
            >{{ $t('login.forgot_password.text') }}</a>
          </div>
        </div>
        <button class="form__button form__button--entery" tabindex="3">{{ $t('login.enter') }}</button>
        <div v-if="showCancel" @click.prevent="$emit('login-canceled')" class="form_button">{{ $t('login.cancel') }}</div>
      </fieldset>
    </template>
  </form>
</template>

<script>
  import axios from 'axios';
  import Password from './PasswordInput'
  import {CONF_WEBUI_LINK, CONF_FORGET_PASSWORD_REDIRECT, CONF_LOGIN_INPUT_LABEL, CONF_BASE_URL} from '@/constants'
  import config from '@/config'

  export default {
    name: 'Authenticate',
    components: {Password},
    data () {
      return {
        auth: '',
        password: '',
        tab: 'login',
        code: '',
        newPassword: '',
        newPasswordRepeat: '',
        showPassword: false,
        forgetPasswordRedirect: config(CONF_FORGET_PASSWORD_REDIRECT) || '',
        BASE_URL: config(CONF_BASE_URL),
        WEBUI_LINK: config(CONF_WEBUI_LINK)
      }
    },
    props: [
      'showCancel',
      'createAccInfo',
      'createAccText'
    ],
    computed: {
      loginInputLabel () {
        const langUpper = this.$store.state.lang.toUpperCase();
        const configLoginInputLabel = config(CONF_LOGIN_INPUT_LABEL);

        if (configLoginInputLabel) {
          return configLoginInputLabel[langUpper] ? configLoginInputLabel[langUpper] : configLoginInputLabel.EN
        }

        return this.$t('login.login_input.placeholder')
      }
    },
    methods: {
      onForgetPasswordClick (e) {
        if (!this.forgetPasswordRedirect) {
          this.$emit('showForgotPassword');
          e.preventDefault();
        }
      },
      isAuthPhone () {
        let phoneReg = /^[+0-9-()\s]{10,}$/;
        let normilizeNumber = this.normalizePhone(this.auth);

        if (phoneReg.test(this.auth)) {
          if (this.auth.charAt(0) === '+') {
            return '+' + normilizeNumber;
          } else if (normilizeNumber.length >= 10) {
            if (normilizeNumber.charAt(0) === '7') {
              return '+' + normilizeNumber;
            } else if (normilizeNumber.charAt(0) === '8') {
              return '+7' + normilizeNumber.substring(1);
            } else {
              return '+7' + normilizeNumber;
            }
          } else {
            return this.auth;
          }
        } else {
          return this.auth
        }
      },
      normalizePhone (number) {
        return number.replace(/[^0-9\(\)\-]/gim, '')
      },
      onPasswordGenerated (newPass) {
        this.newPassword = newPass
        this.newPasswordRepeat = newPass
      },
      async setPassword () {},
      async checkCode () {},
      async sendCode () {},
      showForgotPassword () {
        this.tab = 'forgotPassword'
        this.$emit('hideError')
      },
      showLogin () {
        this.tab = 'login'
        this.password = ''
        this.$emit('hideError')
      },
      onSubmit () {
        this.$validator.validate().then(result => {
          if (result) {
            this.login()
          } else {
            this.getError()
          }
        })
      },
      getError () {
        this.$emit('getError', this.errors.items[0].msg)
      },
      clearErrors () {
        this.$validator.reset();
        this.$emit('hideError')
      },
      async login () {
        // console.log(this.$route.query)
        // return
        const queryClientId = this.$route.query.clientId || this.$route.query.client_id;
        const queryRedirectUri = this.$route.query.redirect_uri;
        const queryState = this.$route.query.state;
        const clientId = queryClientId ? queryClientId : 'lsnuser'
        const login = this.auth
        const password = this.password
        const url = this.BASE_URL + '/openid/authorize'
        const redirectUri = queryRedirectUri ? queryRedirectUri : this.BASE_URL + '/openid/authorize'
        const state = queryState ? encodeURIComponent(queryState) : 'test'
        const params = {login, password, client_id: clientId, redirect_uri: redirectUri, state}

        axios
          .post(url, params)
          .then(function (response) {
            const resp = response.data
            const responseCode = resp.code
            const responseState = resp.state
            const responseRedirectUri = resp.redirect_uri

            console.log(resp)

            if (queryRedirectUri) {
              document.location.href = `${responseRedirectUri}?code=${responseCode}&state=${responseState}`
              return false;
            }

            const lsnUrl = `${config('WEBUI_LINK')}/?code=${responseCode}`

            document.location.href = lsnUrl
          })
          .catch(error => {
            const message = error.response.data.error.message

            if (message === 'incorrect login' || message === 'wrong password') {
              this.$emit('getError', 'Проверьте правильность ввода логина или пароля')
            } else if (message === 'user inactive') {
            //   document.querySelector('.universallogin-page-form__error').textContent = 'Пользователь не активен'
            } else {
            //   document.querySelector('.universallogin-page-form__error').textContent = 'Произошла неизвестная ошибка, попробуйте позже'
            }

            // document.querySelector('.universallogin-page-form__error').classList.add('active');
          });
      },
      setFocus () {
        if (this.$refs.firstInput) {
          this.$refs.firstInput.focus()
        }
      }
    },
    mounted () {
      this.setFocus()
      if (this.$route.params.code) {
        this.checkCode()
      }
    }
  }
</script>

<style lang="scss">
@import 'src/assets/sass/core';

  .form__create-acc {
    font-size: 16px;
    color: #909399;

    ul {
      padding-left: 20px;

      li + li {
        margin-top: 15px;
      }
    }

    a {
      color: #ff5d2b;
      text-decoration: underline;

      &:hover {
        color: #ff5d2b;
        text-decoration: none;
      }
    }
  }
  .loginForm {
    .form--links {
      text-align: center;
      margin-top: -4px;
      flex-direction: column;
      padding-bottom: 27px;

      @include respond-to(phone-s, min) {
        flex-direction: row;
        justify-content: space-between;
        .form__get-account {
          margin-bottom: 0;
        }
      }
      .form__get-account {
        margin-bottom: 13px;
        padding-top: 0;
      }
    }
    .el-input__inner:hover {
      border-color: rgba(146, 145, 153, 1);
    }
    .el-input.is-active .el-input__inner, .el-input__inner:focus {
      border-color: #ff3948;
    }
    .form__forgot-password, .form__get-account {
      a {
        text-decoration: underline;
        border: none;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .cancelForgot {
      margin-top: 15px;
      color: #ACACAC;
      display: block;
      text-align: center;
      cursor: pointer;
      a {
        border-bottom: 1px solid #ACACAC;
      }
    }
    .Password {
      &__badge {
        box-sizing: content-box;
        width: auto;
      }
      &__strength-meter {
        margin-bottom: 5px;
      }
    }
    .form {
      &__button {
        border-radius: 9px;
        background: linear-gradient(89.46deg, #FF3948 -44.58%, #FFAD37 158.4%);
        font-size: 14px;
        font-weight: normal;
        padding-bottom: 13px;
        &:hover {
          box-shadow: 0px 2px 15px 0px rgba(255, 112, 65, 0.5);
        }
        &:active {
          background: linear-gradient(90.6deg, #FF0013 -6.52%, #FF9600 113.08%);
        }
        &--entery {
          margin-top: 1px;
        }
      }
    }
  }
</style>